module.exports = __webpack_public_path__ + "img/warning.a8745d6a.svg";